import { VehicleGroup } from "../data/bruktbilsalgBackend/types/car.types";

export const translateVehicleGroup = (vehicleGroup: VehicleGroup) => {
  switch (vehicleGroup) {
    case "PassengerCar":
      return "Personbil";
    case "Cargo":
      return "Varebil";
    case "Truck":
      return "Lastebil";
    case "Combi":
      return "Kombi";
    case "Minibus":
      return "Minibuss";
    case "LightTruck":
      return "Lett lastebil";
    case "Trailer":
      return "Tilhenger";

    default:
      return "";
  }
};
